    /**
  * For server messages rendered on page load.
  *
  * Usage:
  *
  *   data-sw-flash-message
  *
  *
  */

var _ = require('underscore');
var $ = require('js/sw-jquery/sw-jquery');
var swUtils = require('js/lib/sw-utils');
var swNotifications = require('js/lib/notifications/sw-notifications');

module.exports = function($fragment) {
  $fragment.swFindWithSelf('[data-sw-flash-message]').each(function() {

    var $message = $(this);
    var text = $message.text();
    var dataParams = $message.swDataParams('swFlashMessage');

    dataParams = _.mapObject(dataParams, function removeEmpties(val) {
      return _.isString(val) && _.isEmpty(val) ? undefined : val;
    });

    var waitToDisplay = dataParams.swFlashMessageWait || 0;

    var closeWith = dataParams.swFlashMessageClosewith;

    /* closeWith can accept an array as input ['backdrop', 'button'] e.g.
    *  this code converts the input of "backdrop button " to ['backdrop', 'button']
    *  note: the extra space comes from the mustache iteration
    */

    if(!_.isEmpty(closeWith)) {
      closeWith = closeWith.trim().split(' ');
    }


    // don't fragment load on this unless specifically told to do so.
    var suppressFragmentLoaded = true;
    if(!_.isUndefined(dataParams.swFlashMessageInitFragment)) {
      // Set the inverse w/ !
      suppressFragmentLoaded = !dataParams.swFlashMessageInitFragment;
    }
    var options = {
      closeWith:              closeWith,
      timeout:                dataParams.swFlashMessageTimeout,
      type:                   dataParams.swFlashMessage,
      swTemplate:             dataParams.swFlashMessageTemplate,
      theme:                  dataParams.swFlashMessageTheme,
      layout:                 dataParams.swFlashMessageLayout,
      addClass:               dataParams.swFlashMessageAddClass,
      id:                     dataParams.swFlashMessageNotyId,
      modal:                  dataParams.swFlashMessageModal,
      suppressFragmentLoaded: suppressFragmentLoaded,
      showCloseButton:        dataParams.swFlashMessageShowCloseButton
    };

    _.defaults(options, {
      timeout: false
    });


    swUtils.requestTimeout(function() {
      swNotifications.displayNoty(text, options);
    }, waitToDisplay);
  });
};
